import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAppRealtimeEvent, useAppRealtimeStatus } from './useAppRealtimeEvents';

/**
 * Keeps the package/advance quota fresh without polling: the server pushes `quota.updated`
 * (only to the owner's sockets) after every deduction, and a reconnect refetches to cover
 * events missed while offline.
 */
export function useQuotaRealtimeSync(): void {
  const { applyQuota, refreshQuota } = useAuth();
  const { reconnectCount } = useAppRealtimeStatus();

  useAppRealtimeEvent('quota.updated', (event) => applyQuota(event.data));

  useEffect(() => {
    if (reconnectCount > 0) void refreshQuota();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reconnectCount]);
}
